import { ArticleDetail } from '~/shared/components/Articles/ArticlesList/ArticlesList.types'

import { countWords, organizationSchema, toPlainText } from './Schema.util'

import Schema from './Schema'

import { Element } from './Schema.types'

interface Props {
  blogPost: ArticleDetail
}

function createSchemaObject(blogPost: ArticleDetail): any {
  const articleBody = `${blogPost.title}\n\n${toPlainText(blogPost.content as Element[])}`
  const wordCount = countWords(articleBody)
  return {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    headline: blogPost.title,
    articleBody,
    wordCount,
    image: blogPost.landscapeImage ? [blogPost.landscapeImage.url] : undefined,
    datePublished: blogPost.releaseDate,
    // No dateModified: Sanity's _updatedAt is a batch-sync timestamp, not a real edit date.
    description: blogPost.metaDescription,
    author: {
      '@type': 'Person',
      name: blogPost.author,
      // url: 'http://example.com/profile/johndoe123',
    },
    publisher: organizationSchema,
  }
}

const BlogSchema = ({ blogPost }: Props): React.ReactElement => {
  const schemaObject = createSchemaObject(blogPost)

  return <Schema schemaObject={schemaObject} />
}

export default BlogSchema
